export default "__VITE_ASSET__wKhmuzUO__"